// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Container } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialInvoiceLineState,
    InvoiceLineSchema,
    InvoiceLineFormFields,
    InitialInvoiceLineOtherInvoicesState,
    InvoiceLineOtherInvoicesSchema,
    InvoiceLineOtherInvoicesFormFields,
    InitialInvoiceLineContractState,
    InvoiceLineContractSchema,
    InvoiceLineContractFormFields
} from "./Invoice.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import { invoiceLineTypes } from "./Invoice.utils";

import { TableRow, TableCell } from "@mui/material";
import GoInlineField from "../../../components/Inputs/GoInlineField";

const InvoiceLine = ({ values, touched, errors, handleChange, id, invoiceModel, invoiceHeaderId, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [invoice_line, setInvoiceLine] = useState(invoiceLineTypes[invoiceModel].state);
    const [formFields, setFormFields] = useState(invoiceLineTypes[invoiceModel].formFields);
    const [invoiceLines, setInvoiceLineLines] = useState([]);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleInvoiceLineChange = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.INVOICE_LINES + `/${id}`);
        const data = await response.json();
        setInvoiceLine(data);
        setInvoiceLineLines(data.invoice_lines);
        spinService.off();
    };

    const handleAccountChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("debit_ledger_id", data);
        attachOptions("credit_ledger_id", data);
        spinService.off();
    };

    const handleAreaChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.AREAS, "max=all");
        const data = await response.json();
        attachOptions("area_id", data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewInvoiceLine = values.id === undefined;
        values.invoice_header_id = invoiceHeaderId;
        const url = isNewInvoiceLine ? EntityConstants.INVOICE_LINES : EntityConstants.INVOICE_LINES + `/${values.id}`;
        const method = isNewInvoiceLine ? post : put;
        const response = await method(url, { invoice_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewInvoiceLine ? MessageContants.INVOICE_LINE_CREATED : MessageContants.INVOICE_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    const getMonthEndDate = (month) => {
        const year = new Date().getFullYear()
        const day = new Date(`${month} 1, ${year}`);
        const nextMonth = new Date(day.getFullYear(), day.getMonth() + 1, 0).toLocaleDateString('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });;
        return nextMonth
    }

    const handleValueChange = (e, values) => {
        if (e.target.name === "period") {
            values.post_date = getMonthEndDate(e.target.value);
            return;
        };
        if (e.target.name === "amount") {
            values.credit_amount = e.target.value;
            if (values.vat_percentage === "5%") {
                let vat_amount = (e.target.value / 100) * 5;
                values.vat_amount = vat_amount;
                values.total_amount = Number(e.target.value) + Number(vat_amount);
            } else {
                values.vat_amount = 0;
                values.total_amount = e.target.value;
            }
        };
        if (e.target.name === "vat_percentage") {
            if (e.target.value === "5%") {
                let vat_amount = (values.amount / 100) * 5;
                values.vat_amount = vat_amount;
                values.total_amount = Number(values.amount) + Number(vat_amount);
            } else {
                values.vat_amount = 0;
                values.total_amount = Number(values.amount);
            }
        };
    };

    useEffect(() => {
        if (invoiceModel === "Contract") {
            handleAccountChange();
        } else {
            handleAreaChange();
        }
        if (id !== undefined) {
            handleInvoiceLineChange(Number(id));
        }
        return () => {
            setInvoiceLine(invoiceLineTypes[invoiceModel]["state"]);
        }
    }, [id]);

    return (
        <TableRow
            hover
            key={"action_row"}
            tabIndex={-1}
            role="checkbox"
        >
            {formFields.map((formField, index) => {
                return (
                    <TableCell
                        key={"col" + index}
                    // align={col.align}
                    >
                        <GoInlineField
                            config={formField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
                            onClose={() => onClose()}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
        // <Container>
        //     <Formik
        //         enableReinitialize
        //         initialValues={invoice_line}
        //         validationSchema={myForm[invoiceModel]["schema"]}
        //         onSubmit={(values) => handleSubmit(values)}
        //     >
        //         {({
        //             values,
        //             touched,
        //             errors,
        //             handleChange,
        //             handleSubmit,
        //         }) => (
        //             <Form noValidate onSubmit={handleSubmit}>
        //                 <StyledDrawerForm>
        //                     <Grid
        //                         container
        //                         maxWidth="sm"
        //                         rowSpacing={1}
        //                         columnSpacing={{ xs: 1, sm: 2, md: 2 }}
        //                     >
        //                         {formFields.map((formField, index) => {
        //                             return (
        //                                 <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
        //                                     <GoForm
        //                                         config={formField}
        //                                         values={values}
        //                                         touched={touched}
        //                                         errors={errors}
        //                                         handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
        //                                     />
        //                                 </Grid>
        //                             );
        //                         })}
        //                     </Grid>
        //                     <Box sx={{ p: 2, textAlign: "right" }}>
        //                         <Button
        //                             variant="contained"
        //                             color="error"
        //                             startIcon={<Iconify icon="eva:close-circle-outline" />}
        //                             onClick={() => onClose()}
        //                         >
        //                             Close
        //                         </Button>
        //                         &nbsp;&nbsp;
        //                         {((values.id === undefined && permissions.has(PermissionConstants.INVOICE_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.INVOICE_UPDATE))) &&

        //                             <Button
        //                                 variant="contained"
        //                                 startIcon={<Iconify icon="eva:save-fill" />}
        //                                 type="submit"
        //                             >
        //                                 {values.id === undefined ? 'Save' : 'Update'}
        //                             </Button>
        //                         }
        //                     </Box>
        //                 </StyledDrawerForm>
        //             </Form>
        //         )}
        //     </Formik>
        // </Container>
    );
};

InvoiceLine.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default InvoiceLine;
